import { handleActions } from 'redux-actions';
import { handleSetState } from '../utils';
import { aceptarTerminosAction, setLoadingAction } from './actions';

export type LoadingStateType = {
  loading?: boolean;
  principal?: string;
  secundario?: string;
};

export const defaultLoadingState: LoadingStateType = {
  loading: false,
  principal: 'Cargando formas de pago',
  secundario: 'Espere por favor',
};

const initialState = {
  terminosAceptados: false,
  loadingState: defaultLoadingState,
};

export type PaginaPagoStateType = typeof initialState;

const PaginaPagoReducer = handleActions(
  {
    [aceptarTerminosAction as any]: handleSetState('terminosAceptados'),
    [setLoadingAction as any]: handleSetState('loadingState'),
  },
  initialState,
);

export default PaginaPagoReducer;
